import { render, staticRenderFns } from "./OCC-Contact.vue?vue&type=template&id=9915b802&scoped=true&"
var script = {}
import style0 from "./OCC-Contact.vue?vue&type=style&index=0&id=9915b802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9915b802",
  null
  
)

export default component.exports